//https://blogs.msdn.microsoft.com/premier_developer/2017/05/11/add-application-insights-to-an-angular-spa/

import { Injectable } from '@angular/core';

import { AppInsights } from 'applicationinsights-js';

import { Config } from '../entities/entities';
import { ConfigService } from './config.service';

@Injectable()
export class LoggingService {

    private config: Microsoft.ApplicationInsights.IConfig;

    constructor(private configService: ConfigService) {
        try {
            this.config = {
                instrumentationKey: configService.Current.instrumentationKey
            };

            if (!AppInsights.config) {
                AppInsights.downloadAndSetup(this.config);
            }
        } catch (err) {
            console.error(err);
        }
    }

    logPageView(name?: string, url?: string, properties?: any,
        measurements?: any, duration?: number) {
        try {
            AppInsights.trackPageView(name, url, properties, measurements, duration);
        } catch (err) {
            console.error(err);
        }
    }

    logEvent(name: string, properties?: any, measurements?: any) {
        try {
            AppInsights.trackEvent(name, properties, measurements);
        } catch (err) {
            console.error(err);
        }

    } 

    logError(exc: Error, handledAt?: string, properties?: { [name: string]: string }) {
        try {
            AppInsights.trackException(exc, handledAt, properties);
        } catch (err) {
            console.error(err);
        }
    }
} 


// WEBPACK FOOTER //
// D:/a/1/s/src/app/services/logging.service.ts